// extracted by mini-css-extract-plugin
export default {"fieldset":"bPDouE8BV03wLH0oLNRS"};